import { useStaff, useStaffTotals } from "./useStaff";
import { StaffSection } from "./StaffSection";
import type { StaffRoleKey } from "@shared/types/staff";

interface SectionConfig {
  key: StaffRoleKey;
  title: string;
  column: 0 | 1 | 2;
}

const SECTIONS: SectionConfig[] = [
  { key: "avp", title: "Assistant Vice President", column: 0 },
  { key: "executives", title: "Executive", column: 0 },
  { key: "executivesWithAssistants", title: "Executive w/ Assistant", column: 0 },
  { key: "juniors", title: "Juniors", column: 1 },
  { key: "lsc", title: "LSC", column: 1 },
  { key: "seniors", title: "Senior", column: 2 },
];

export function StaffTables() {
  const { data: staff } = useStaff();
  const { data: totals } = useStaffTotals();

  const columns: SectionConfig[][] = [[], [], []];
  for (const section of SECTIONS) {
    columns[section.column]!.push(section);
  }

  return (
    <div className="w-3/4 flex flex-col">
      <div className="text-right text-sm pr-[1%] pb-1">
        ** APP and JR2 are for the current week
      </div>
      <div className="flex w-full">
        {columns.map((sectionsInColumn, idx) => (
          <div key={idx} className="flex-1">
            {sectionsInColumn.map((section) => (
              <StaffSection
                key={section.key}
                title={section.title}
                rows={staff?.[section.key]}
                totals={totals?.[section.key]}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
